import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// Lazy load components for better performance
const Home = lazy(() => import('./components/Home'));
const AboutBrady = lazy(() => import('./components/AboutBrady'));
const Content = lazy(() => import('./components/Content'));
const ApplyGuest = lazy(() => import('./components/ApplyGuest'));
const Guests = lazy(() => import('./components/Guests'));
const FAQ = lazy(() => import('./components/FAQ'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const Contact = lazy(() => import('./components/Contact'));
const NotFound = lazy(() => import('./components/NotFound'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <AboutBrady />,
  },
  {
    path: '/episodes',
    element: <Content />,
  },
  {
    path: '/guests',
    element: <Guests />,
  },
  {
    path: '/apply',
    element: <ApplyGuest />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms',
    element: <TermsOfService />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);